import React, { useState, useEffect } from 'react';
import './ecs2-banner.css';
import CONFIG from '../../config';

const ECS2_URL = CONFIG.ECS2_URL;
const ANNOUNCEMENT_SNOOZE_MS = 10 * 60 * 1000; // 10 minutes
const ANNOUNCEMENT_DISMISSED_AT_KEY = 'ecs2_announcement_dismissed_at';

function isAnnouncementSnoozed() {
    const dismissedAt = localStorage.getItem(ANNOUNCEMENT_DISMISSED_AT_KEY);
    if (!dismissedAt) return false;
    return (Date.now() - Number(dismissedAt)) < ANNOUNCEMENT_SNOOZE_MS;
}

export function Ecs2AnnouncementBar() {
    const [dismissed, setDismissed] = useState(isAnnouncementSnoozed);

    useEffect(() => {
        const appDiv = document.querySelector('.App');
        if (!dismissed && appDiv) {
            appDiv.classList.add('ecs2-bar-visible');
        }
        return () => {
            if (appDiv) appDiv.classList.remove('ecs2-bar-visible');
        };
    }, [dismissed]);

    // Automatically bring the bar back once the snooze window elapses
    useEffect(() => {
        if (!dismissed) return;
        const dismissedAt = Number(localStorage.getItem(ANNOUNCEMENT_DISMISSED_AT_KEY));
        const remaining = ANNOUNCEMENT_SNOOZE_MS - (Date.now() - dismissedAt);
        if (remaining <= 0) {
            setDismissed(false);
            return;
        }
        const timer = setTimeout(() => setDismissed(false), remaining);
        return () => clearTimeout(timer);
    }, [dismissed]);

    if (dismissed) return null;

    const handleDismiss = () => {
        localStorage.setItem(ANNOUNCEMENT_DISMISSED_AT_KEY, String(Date.now()));
        const appDiv = document.querySelector('.App');
        if (appDiv) appDiv.classList.remove('ecs2-bar-visible');
        setDismissed(true);
    };

    return (
        <>
            <div className="ecs2-announcement-bar">
                <span className="ecs2-new-badge">NEW</span>
                <span className="ecs2-bar-text">
                    <strong>ECS 2.0 is now live!</strong> Blazing-fast real-time search, redesigned UI, and smarter workflows. Switch today!
                </span>
                <a
                    href={ECS2_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ecs2-try-btn"
                >
                    Try ECS 2.0
                </a>
                <button
                    className="ecs2-dismiss-btn"
                    onClick={handleDismiss}
                    aria-label="Dismiss announcement"
                >
                    ✕
                </button>
            </div>
            <div className="ecs2-bar-spacer" />
        </>
    );
}

// export function Ecs2PromotionCard() {
//     const [dismissed, setDismissed] = useState(
//         () => localStorage.getItem('ecs2_promo_dismissed') === 'true'
//     );

//     if (dismissed) return null;

//     const handleDismiss = () => {
//         localStorage.setItem('ecs2_promo_dismissed', 'true');
//         setDismissed(true);
//     };

//     return (
//         <div className="ecs2-promo-card">
//             <div className="ecs2-promo-icon">
//                 <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                     <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
//                           fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//                 </svg>
//             </div>
//             <div className="ecs2-promo-content">
//                 <h3>
//                     Enterprise Customer Search
//                     <span className="ecs2-version-tag">2.0</span>
//                 </h3>
//                 <p>
//                     Experience lightning-fast, real-time search with a completely
//                     redesigned modern interface and smarter filtering.
//                 </p>
//                 <div className="ecs2-promo-features">
//                     <span className="ecs2-feature-chip">
//                         <span className="ecs2-chip-icon">&#10003;</span> Real-Time Search
//                     </span>
//                     <span className="ecs2-feature-chip">
//                         <span className="ecs2-chip-icon">&#10003;</span> Faster Results
//                     </span>
//                     <span className="ecs2-feature-chip">
//                         <span className="ecs2-chip-icon">&#10003;</span> Modern UI
//                     </span>
//                     <span className="ecs2-feature-chip">
//                         <span className="ecs2-chip-icon">&#10003;</span> Smart Filters
//                     </span>
//                 </div>
//                 <div className="ecs2-promo-actions">
//                     <a
//                         href={ECS2_URL}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="ecs2-explore-btn"
//                     >
//                         Explore ECS 2.0
//                         <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                             <path d="M5 12h14M12 5l7 7-7 7" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//                         </svg>
//                     </a>
//                     <button className="ecs2-dismiss-link" onClick={handleDismiss}>
//                         Maybe later
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }

export function Ecs2FloatingBadge() {
    return (
        <div className="ecs2-floating-badge">
            <a
                href={ECS2_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="ecs2-badge-btn"
            >
                <span className="ecs2-rocket">&#128640;</span>
                <span className="ecs2-badge-label">Try ECS 2.0</span>
            </a>
        </div>
    );
}
